import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-under-construction',
  templateUrl: './under-construction.component.html',
  styleUrls: ['./under-construction.component.css']
})
export class UnderConstructionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
